module.exports = require('./lib/axios');


/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/index.js
 ** module id = 21
 ** module chunks = 0
 **/